var defaultConfigs = ['base','dev','local'];

if(process.env.NODE_ENV ===  'production'){
    defaultConfigs = ['base','prod','local'];
}
if(process.env.NODE_ENV ===  'test'){
    defaultConfigs = ['base','test','local'];
}
console.log(process.env.NODE_ENV);
function getConfig(configNames) {
    configNames = configNames || defaultConfigs;
    var configObj = {};
    configNames.forEach(function (filename) {
        try{
            var obj = require('./'+filename);
            Object.assign(configObj,obj);
        }catch(e){}
    });
    return configObj;
}

var config = getConfig();
module.exports = config;



// WEBPACK FOOTER //
// config/index.js